export default class TokenData  {

    constructor(obj){
        this.TKNUserID=obj.TKNUSERID;
        this.TKNUserTAG=obj.TKNUSERTAG;
        this.TKNToken=obj.TKNTOKEN;
        this.TKNStartActivity=obj.TKNSTARTACTIVITY;
        this.TKNLastActivity=obj.TKNLASTACTIVITY;
  
    }

}